import { Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import SharedForm from '../../components/ui/Form';
import { ALIGN, POSITIONS } from '../../constants';
import { toDateTime } from '../../utils/utils';
import styles from './ViewCohortUpdateModal.module.scss';
import api from '../../services/api/cohortService';
import Loader from "../../components/ui/Loader";

const UpdateItem = ({ label, count, bgColor }) => {
    return (
        <div className={`d-flex justify-content-between px-3 py-1 ${styles.updateItem} ${styles[bgColor]}`}>
            <span className="fw-bold">{label}:</span> {count}
        </div>
    )
}

const ViewCohortUpdateModal = ({ show, data, onCancel }) => {
    const [cohortUpdateDetails, setCohortUpdateDetails] = useState(null);
    const arr = [
        { key: 'cohortName', labelName: 'Cohort', type: 'text', required: false },
    ];

    useEffect(() => {
        if (data) {
            api.getCohortUpdateCountByCohortUpdateId(data.id).then(response => {
                const { data } = response;
                setCohortUpdateDetails({
                    ...data,
                    createdDate: toDateTime(data.createdDate),
                    modifiedDate: toDateTime(data.modifiedDate),
                });
            });
        }
    }, [data]);

    return (
        <>
            {cohortUpdateDetails === null ? (
                <Loader />
            ) : (
                <Modal
                    show={show}
                    fullscreen={false}
                    backdrop="static"
                    onHide={onCancel}
                    size="md">
                    <Modal.Header closeButton>
                        <Modal.Title>Cohort Update Counts</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="px-xl-3 py-xl-2">
                            <SharedForm
                                cols={12}
                                array={arr}
                                modelObj={cohortUpdateDetails}
                                viewOnly={true}
                                actionBarPosition={POSITIONS.TOP}
                                actionBarAlign={ALIGN.RIGHT}
                            />

                            <div className="mt-3 pt-3 border-top">
                                <h4 className="sub-title mb-2 lh-sm">Update Summary</h4>
                                <div className={`d-flex flex-column gap-2 bg-white rounded p-3 ${styles.updateSummary}`}>
                                    <UpdateItem bgColor="red" label="Members Unenrolled" count={cohortUpdateDetails?.unenrollMemberCount} />
                                    <UpdateItem bgColor="green" label="Members Added" count={cohortUpdateDetails?.addMemberCount} />
                                    <UpdateItem bgColor="yellow" label="Members in Exception" count={cohortUpdateDetails?.exceptionMemberCount} />
                                    <UpdateItem bgColor="grey" label="Members with Updated Data" count={cohortUpdateDetails?.updateMemberCount} />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}

export default ViewCohortUpdateModal;
